import { Box } from "@material-ui/core";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import TableFilters from "views/SMS/MySMS/TableFilters";
import FavouritesTable from "./FavouritesTable";
import useGetReportsTableData from "../useGetReportsTableData";
import useGetFilterOptions from "../useGetFilterOptions";
import ReportsAction from "../ReportsAction";

const Favourites = forwardRef((props, ref) => {
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [openAction, setOpenAction] = useState({
    isOpen: false,
    currentSelection: null,
  });

  const [filterValues, setFilterValues] = useState({
    category_id: "",
  });

  const handleSearchTextChange = (value) => {
    setPage(0);
    setSearchText(value);
  };

  const handleFilterChange = (filterId, event) => {
    setFilterValues((prev) => {
      return { ...prev, [filterId]: event.target.value };
    });
  };

  const filterOptions = useGetFilterOptions();

  const { loading, totalCount, tableData, refetch } = useGetReportsTableData(
    filterValues,
    searchText,
    page,
    pageSize,
    "favourites"
  );

  const filtersList = [
    {
      name: "category_id",
      options: [
        { id: "", value: "Category (All)" },
        ...(filterOptions?.categories || []),
      ],
    },
  ];

  useImperativeHandle(ref, () => ({ refetch }));

  const handleOpenAction = (selected) => {
    if (!selected) return;
    setOpenAction({ isOpen: true, currentSelection: selected });
  };

  const handleCloseActions = () => {
    setOpenAction({ isOpen: false, currentSelection: null });
  };

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      style={{ gap: "1rem", padding: "0rem 2rem" }}>
      <TableFilters
        handleFilterChange={handleFilterChange}
        searchText={searchText}
        filterValues={filterValues}
        handleSearchTextChange={handleSearchTextChange}
        filtersList={filtersList}
      />

      <FavouritesTable
        setPage={setPage}
        page={page}
        setPageSize={setPageSize}
        pageSize={pageSize}
        totalCount={totalCount}
        tableData={tableData}
        loading={loading}
        handleOpenAction={handleOpenAction}
      />

      {openAction.isOpen && openAction.currentSelection ? (
        <ReportsAction
          handleCloseAction={handleCloseActions}
          currentSelection={openAction.currentSelection}
          refreshListing={refetch}
        />
      ) : null}
    </Box>
  );
});

export default Favourites;
